import React from "react";
import { TailSpin } from "react-loader-spinner";

type LoaderProps = {
    className?: string;
};
export const Loader = (props: LoaderProps) => {
    return (
        <TailSpin
            height="60"
            width="60"
            color="#004c3f"
            ariaLabel="tail-spin-loading"
            radius="1"
            visible={true}
            wrapperClass={props.className}
        />
    );
};
